import axios from "axios";
const baseUrl = "/api/v1";

// This file specifically will be for list data
export const list = {
  get: (params, tab) => axios.get(`${baseUrl}/${tab}`, params),
  post: (payload, tab, config) =>
    axios.post(`${baseUrl}/${tab}/search`, payload, config),
  put: (payload, tab) => axios.put(`${baseUrl}/${tab}/${payload.id}`, payload),
  create: (payload, tab) => axios.post(`${baseUrl}/${tab}`, payload),
  delete: (id, tab) => axios.delete(`${baseUrl}/${tab}/${id}`),
  getOne: (id, tab) => axios.get(`${baseUrl}/${tab}/${id}`),
};
